import { VenueData, LocationEntry } from './venueData';
import { findPathMulti } from './pathfinder';

export interface Gate {
  id: string;
  name: string;
  nodeId: string;
  coords: [number, number];
  extStart: [number, number];
}

export const GATES: Gate[] = [
  {
    id: 'main_1',
    name: 'Main Gate 1',
    nodeId: 'n_c3b040786c1b7f1b',
    coords: [74.79304560253175, 13.351138556614453],
    extStart: [74.79304560253175, 13.35104]
  },
  {
    id: 'main_2',
    name: 'Main Gate 2',
    nodeId: 'n_a72b0816c90aff21',
    coords: [74.79301614601519, 13.351141270039388],
    extStart: [74.79301614601519, 13.35104]
  },
  {
    id: 'side_a',
    name: 'Side Gate A',
    nodeId: 'n_04309b7c003dbee5',
    coords: [74.7929311268427, 13.35126739183507],
    extStart: [74.79282, 13.35126739183507]
  },
  {
    id: 'side_b',
    name: 'Side Gate B',
    nodeId: 'n_0fac5fe11fc6e487',
    coords: [74.79294410995745, 13.35129699734823],
    extStart: [74.79282, 13.35129699734823]
  }
];

export function getGatesForBuilding(buildingId: string): Gate[] {
  const bid = buildingId.toLowerCase();
  if (bid === 'ab4') {
    return [
      {
        id: 'main_1',
        name: 'Main Entrance',
        nodeId: 'n_7d8c98750dc74359',
        coords: [74.7926495, 13.3513733],
        extStart: [74.79275, 13.3513733]
      }
    ];
  }
  if (bid === 'ab1') {
    return [
      {
        id: 'main_1',
        name: 'Main Entrance',
        nodeId: 'n_226ba2fce821c9d3',
        coords: [74.79267185, 13.35311144],
        extStart: [74.7926623, 13.3531086]
      }
    ];
  }
  if (bid === 'ab2') {
    return [
      {
        id: 'main_1',
        name: 'Main Entrance',
        nodeId: 'n_364100c340aca37e',
        coords: [74.7937585, 13.3522572],
        extStart: [74.7937585, 13.35215]
      },
      {
        id: 'side_a',
        name: 'Side Entrance A',
        nodeId: 'n_8ca001ccbe7080dd',
        coords: [74.7936191, 13.3524987],
        extStart: [74.7935, 13.3524987]
      },
      {
        id: 'side_b',
        name: 'Side Entrance B',
        nodeId: 'n_100c340aca37ec9a',
        coords: [74.7937961, 13.3523785],
        extStart: [74.7937961, 13.35228]
      }
    ];
  }
  if (bid === 'ab5') {
    return [
      {
        id: 'main_1',
        name: 'Main Entrance',
        nodeId: 'n_d92de8a042801011',
        coords: [74.79326965218348, 13.35337787095175],
        extStart: [74.7932, 13.35337787095175]
      }
    ];
  }
  return GATES;
}

export function getElevatorSpaceId(buildingId: string, floorId: string): string {
  const bid = buildingId.toLowerCase();
  if (bid === 'ab4') {
    const mapping: Record<string, string> = {
      'm_eed3e5d1ce8cd49e': 's_207ae4861721d30e', // Ground Floor
      'm_d43429dcf0418992': 's_9ebb7af932e31d4a', // First Floor
      'm_27e0ac7f86e42cc9': 's_3a535c939ea46838', // Second Floor
      'm_488785c95e4262df': 's_4f8b6328cd2d22a2', // Third Floor
      'm_56786e2cbf403140': 's_cde89a20a919b990', // Fourth Floor
      'm_f41ac9a88e6987ff': 's_33da277a2004ac8a', // Fifth Floor
    };
    return mapping[floorId] || 's_207ae4861721d30e';
  }
  if (bid === 'ab1') {
    const mapping: Record<string, string> = {
      'm_66eeefc248e39862': 's_c4d67912a1295414', // Basement (using lift)
      'm_8740f39750314ebd': 's_64f6c46f082807c5', // Ground Floor (using stairs Set 2)
      'm_a1f82129fc03889b': 's_9a1434465c95d001', // First Floor (using stairs Set 2)
      'm_2df65038b04c6a95': 's_f506a60c01c345c5', // Second Floor (using stairs Set 2)
    };
    return mapping[floorId] || 's_64f6c46f082807c5';
  }
  if (bid === 'ab2') {
    const mapping: Record<string, string> = {
      'm_2c03e79595c6e200': 's_835138ef45669650', // Basement Floor 2
      'm_6589068b82883504': 's_50578a51a195ee86', // Basement Floor 1
      'm_4710045c396f56cf': 's_051d4d1b103753d7', // Ground Floor
      'm_036743853a014dd2': 's_b26a69ef28e0e737', // First Floor
      'm_a2d21224b8803f7c': 's_8c2259ef8b0fa8bb', // Second Floor
      'm_6c2f67d670589d76': 's_212e1d309eac5bf6', // Third Floor
    };
    return mapping[floorId] || 's_051d4d1b103753d7';
  }
  if (bid === 'ab5') {
    const mapping: Record<string, string> = {
      'm_470ea2fd2ab981dd': 's_4c3ae857a5ae4bd0', // lower ground 1
      'm_65b9d5f84eac4e5c': 's_6522e42b0f2074fe', // Ground Floor
      'm_4b3d7ee4ca112b83': 's_25584239b775be46', // First Floor
      'm_2ae1c9d52d5a9470': 's_a87a95ce8e0ba5c7', // Second Floor
      'm_5a0e4666d0572af2': 's_9df288861088cb1b', // Third Floor
      'm_06c12e5a0566eef4': 's_f5728264ddac01dd', // Fourth Floor
      'm_2902fc1d3571102b': 's_6cf4e38ec97623d4', // Fifth Floor
    };
    return mapping[floorId] || 's_a87a95ce8e0ba5c7';
  }
  return 's_63d38be0872dd520'; // AB3
}

export interface NavigationStep {
  title: string;
  description: string;
  icon: string;
  isActive: boolean;
  isCompleted: boolean;
  floorId?: string;
  action?: {
    label: string;
    targetFloorId: string;
  };
}

export interface RouteCalculationResult {
  fromId: string;
  toId: string;
  currentFloorId: string;
  route: [number, number][];
  highlighted: string[];
  extStart?: [number, number];
  selectedGateId: string;
  multiFloorRoutes: {
    leg1?: [number, number][];
    leg2?: [number, number][];
    fromFloorId?: string;
    toFloorId?: string;
  } | null;
  steps: NavigationStep[];
}

export const floorLabels: Record<string, string> = {
  'm_fa5a3ee91d369d98': 'Ground Floor',
  'first': '1st Floor',
  'second': '2nd Floor',
  'third': '3rd Floor',
  // AB4 Floors
  'm_eed3e5d1ce8cd49e': 'Ground Floor',
  'm_d43429dcf0418992': '1st Floor',
  'm_27e0ac7f86e42cc9': '2nd Floor',
  'm_488785c95e4262df': '3rd Floor',
  'm_56786e2cbf403140': '4th Floor',
  'm_f41ac9a88e6987ff': '5th Floor',
  // AB1 Floors
  'm_7732645c0b6c4cb8': '2nd Floor',
  'm_8740f39750314ebd': 'Ground Floor',
  'm_a1f82129fc03889b': '1st Floor',
  'm_2df65038b04c6a95': '2nd Floor',
  'm_66eeefc248e39862': 'Basement',
  // AB2 Floors
  'm_2c03e79595c6e200': 'Basement 2',
  'm_6589068b82883504': 'Basement 1',
  'm_4710045c396f56cf': 'Ground Floor',
  'm_036743853a014dd2': '1st Floor',
  'm_a2d21224b8803f7c': '2nd Floor',
  'm_6c2f67d670589d76': '3rd Floor',
  // AB5 Floors
  'm_470ea2fd2ab981dd': 'LG1 Floor',
  'm_65b9d5f84eac4e5c': 'Ground Floor',
  'm_4b3d7ee4ca112b83': '1st Floor',
  'm_2ae1c9d52d5a9470': '2nd Floor',
  'm_5a0e4666d0572af2': '3rd Floor',
  'm_06c12e5a0566eef4': '4th Floor',
  'm_2902fc1d3571102b': '5th Floor'
};

/**
 * Calculates raw coordinates between nodes or spaces.
 */
export function get2DPath(
  data: VenueData,
  fromSpOrNode: string,
  toSp: string,
  isExt: boolean = false
): { coords: [number, number][]; distance: number } | null {
  const startNodes = isExt
    ? [fromSpOrNode]
    : (data.spaceToDestNodes.get(fromSpOrNode) || []);
  const endNodes = (data.spaceToDestNodes.get(toSp) || []).map(id => ({ id, spaceId: toSp }));
  const startPrepared = startNodes.map(id => ({ id, spaceId: isExt ? 'CORRIDOR' : fromSpOrNode }));
  
  const result = findPathMulti(startPrepared, endNodes, data);
  if (!result) return null;

  const coords = result.nodes.map(id => {
    const node = data.nodeById.get(id);
    return node ? [node.lng, node.lat] as [number, number] : null;
  }).filter((c): c is [number, number] => c !== null);

  return { coords, distance: result.distance };
}

/**
 * Auto-calculates the optimal active building gate.
 */
export function calculateOptimalGate(
  data: VenueData,
  toLoc: LocationEntry,
  closedGates: string[],
  gates: Gate[],
  buildingId: string = 'ab3'
): string {
  const bid = buildingId.toLowerCase();
  const isAB4 = bid === 'ab4';
  const isAB1 = bid === 'ab1';
  const isAB2 = bid === 'ab2';
  const isAB5 = bid === 'ab5';
  const groundFloorId = isAB4 
    ? 'm_eed3e5d1ce8cd49e' 
    : (isAB1 
        ? 'm_8740f39750314ebd' 
        : (isAB2 
            ? 'm_4710045c396f56cf'
            : (isAB5 ? 'm_2ae1c9d52d5a9470' : 'm_fa5a3ee91d369d98')));
  const isUpperFloor = toLoc.floorId !== groundFloorId;
  
  const availableGates = gates.filter(g => {
    if (closedGates.includes(g.id)) return false;
    if (isUpperFloor && (g.id === 'side_a' || g.id === 'side_b')) return false;
    return true;
  });

  if (availableGates.length === 0) return gates[0].id;

  let bestGateId = availableGates[0].id;
  let minDistance = Infinity;

  const elevatorSpaceId = getElevatorSpaceId(bid, toLoc.floorId);
  const groundElevatorSpaceId = getElevatorSpaceId(bid, groundFloorId);

  for (const gate of availableGates) {
    if (isUpperFloor) {
      const p1 = get2DPath(data, gate.nodeId, groundElevatorSpaceId, true);
      const p2 = get2DPath(data, elevatorSpaceId, toLoc.spaceId, false);
      if (p1 && p2) {
        const total = p1.distance + p2.distance;
        if (total < minDistance) {
          minDistance = total;
          bestGateId = gate.id;
        }
      }
    } else {
      const p = get2DPath(data, gate.nodeId, toLoc.spaceId, true);
      if (p && p.distance < minDistance) {
        minDistance = p.distance;
        bestGateId = gate.id;
      }
    }
  }

  return bestGateId;
}

/**
 * Generates turn-by-turn directions strictly in natural, human landmark-based language.
 */
export function generateSemanticSteps(
  fromLocName: string,
  toLocName: string,
  gateName: string,
  isMultiFloor: boolean,
  fromFloorId: string,
  toFloorId: string,
  currentFloorId: string
): NavigationStep[] {
  const steps: NavigationStep[] = [];
  const fromFloorLabel = floorLabels[fromFloorId] || 'Current Level';
  const toFloorLabel = floorLabels[toFloorId] || 'Target Level';

  const cleanLocName = (name: string) => {
    if (name.includes('(')) {
      return name.split('(')[0].trim();
    }
    return name;
  };

  const startLocClean = cleanLocName(fromLocName);
  const endLocClean = cleanLocName(toLocName);

  if (fromLocName === 'EXTERNAL') {
    // 1. Enter building through Gate landmark
    steps.push({
      title: 'Enter Campus Gate',
      description: `Enter through ${gateName}.`,
      icon: 'door',
      isActive: currentFloorId === fromFloorId,
      isCompleted: isMultiFloor && currentFloorId !== fromFloorId
    });

    if (isMultiFloor) {
      // 2. Guide to shared vertical node (Elevator)
      steps.push({
        title: 'Walk to Elevator',
        description: 'Walk to the central elevator on the Ground Floor.',
        icon: 'walk',
        isActive: currentFloorId === fromFloorId,
        isCompleted: currentFloorId !== fromFloorId
      });

      // 3. Pause & Prompt manual floor switch at Vertical Shaft
      steps.push({
        title: 'Elevator Shaft',
        description: `Take the elevator to the ${toFloorLabel}.`,
        icon: 'elevator',
        floorId: toFloorId,
        isActive: true,
        isCompleted: currentFloorId === toFloorId,
        action: currentFloorId !== toFloorId ? {
          label: `Switch to ${toFloorLabel}`,
          targetFloorId: toFloorId
        } : undefined
      });

      // 4. Arrive at Classroom landmark
      steps.push({
        title: 'Arrive at Destination',
        description: `Your destination, ${endLocClean}, is on the right after exiting the elevator.`,
        icon: 'pin',
        isActive: currentFloorId === toFloorId,
        isCompleted: false
      });
    } else {
      // Same level (Ground)
      steps.push({
        title: 'Walk to Classroom',
        description: `Follow the corridor straight to ${endLocClean} on the Ground Floor.`,
        icon: 'walk',
        isActive: true,
        isCompleted: false
      });

      steps.push({
        title: 'Destination Reached',
        description: `Your destination, ${endLocClean}, is straight ahead.`,
        icon: 'pin',
        isActive: true,
        isCompleted: false
      });
    }
  } else {
    // Internal-to-Internal
    if (isMultiFloor) {
      steps.push({
        title: 'Leave Room',
        description: `Walk out of ${startLocClean} and make your way to the central elevator.`,
        icon: 'walk',
        isActive: currentFloorId === fromFloorId,
        isCompleted: currentFloorId !== fromFloorId
      });

      steps.push({
        title: 'Elevator Shaft',
        description: `Take the elevator to the ${toFloorLabel}.`,
        icon: 'elevator',
        floorId: toFloorId,
        isActive: true,
        isCompleted: currentFloorId === toFloorId,
        action: currentFloorId !== toFloorId ? {
          label: `Switch to ${toFloorLabel}`,
          targetFloorId: toFloorId
        } : undefined
      });

      steps.push({
        title: 'Arrive at Destination',
        description: `Your destination, ${endLocClean}, will be straight ahead on the ${toFloorLabel}.`,
        icon: 'pin',
        isActive: currentFloorId === toFloorId,
        isCompleted: false
      });
    } else {
      // Same floor internal
      steps.push({
        title: 'Walk Corridor',
        description: `Walk down the corridor from ${startLocClean} to ${endLocClean} on the ${fromFloorLabel}.`,
        icon: 'walk',
        isActive: true,
        isCompleted: false
      });

      steps.push({
        title: 'Destination Reached',
        description: `Your destination, ${endLocClean}, is on your left.`,
        icon: 'pin',
        isActive: true,
        isCompleted: false
      });
    }
  }

  return steps;
}

/**
 * Calculates a complete navigation route across environmental transitions.
 */
export function computeRoute(
  data: VenueData,
  fromLocId: string,
  toLocId: string,
  closedGates: string[],
  currentFloorId: string,
  buildingId: string = 'ab3'
): RouteCalculationResult | null {
  const isExternal = fromLocId === 'EXTERNAL';
  const toLoc = data.locations.find(l => l.id === toLocId);
  if (!toLoc) return null;

  const bid = buildingId.toLowerCase();
  const isAB4 = bid === 'ab4';
  const isAB1 = bid === 'ab1';
  const isAB2 = bid === 'ab2';
  const isAB5 = bid === 'ab5';
  const groundFloorId = isAB4 
    ? 'm_eed3e5d1ce8cd49e' 
    : (isAB1 
        ? 'm_8740f39750314ebd' 
        : (isAB2
            ? 'm_4710045c396f56cf'
            : (isAB5 ? 'm_2ae1c9d52d5a9470' : 'm_fa5a3ee91d369d98')));
  const gates = getGatesForBuilding(bid);

  let optimalGateId = gates[0].id;
  let activeGate = gates[0];

  if (isExternal) {
    optimalGateId = calculateOptimalGate(data, toLoc, closedGates, gates, buildingId);
    activeGate = gates.find(g => g.id === optimalGateId) || gates[0];
  }

  let finalRoute: [number, number][] = [];
  let multiFloorRoutes: RouteCalculationResult['multiFloorRoutes'] = null;
  let isMultiFloor = false;
  let fromFloorId = groundFloorId;
  let activeFloorId = currentFloorId;

  if (isExternal) {
    if (toLoc.floorId === groundFloorId) {
      const p = get2DPath(data, activeGate.nodeId, toLoc.spaceId, true);
      finalRoute = p ? (p.coords.length > 0 ? [activeGate.extStart, ...p.coords] : []) : [];
      activeFloorId = groundFloorId;
    } else {
      const p1 = get2DPath(data, activeGate.nodeId, getElevatorSpaceId(buildingId, groundFloorId), true);
      const p2 = get2DPath(data, getElevatorSpaceId(buildingId, toLoc.floorId), toLoc.spaceId, false);
      
      const leg1Coords: [number, number][] = p1 ? (p1.coords.length > 0 ? [activeGate.extStart, ...p1.coords] : []) : [];
      const leg2Coords: [number, number][] = p2 ? p2.coords : [];

      multiFloorRoutes = {
        leg1: leg1Coords,
        leg2: leg2Coords,
        fromFloorId: groundFloorId,
        toFloorId: toLoc.floorId
      };
      
      isMultiFloor = true;
      fromFloorId = groundFloorId;
      
      // Start on the ground floor to show the route coming from outside
      finalRoute = leg1Coords;
      activeFloorId = groundFloorId;
    }
  } else {
    const fromLoc = data.locations.find(l => l.id === fromLocId);
    if (!fromLoc) return null;
    
    fromFloorId = fromLoc.floorId;

    if (fromLoc.floorId === toLoc.floorId) {
      const p = get2DPath(data, fromLoc.spaceId, toLoc.spaceId, false);
      finalRoute = p ? p.coords : [];
      activeFloorId = fromLoc.floorId;
    } else {
      const p1 = get2DPath(data, fromLoc.spaceId, getElevatorSpaceId(buildingId, fromLoc.floorId), false);
      const p2 = get2DPath(data, getElevatorSpaceId(buildingId, toLoc.floorId), toLoc.spaceId, false);
      
      const leg1Coords: [number, number][] = p1 ? p1.coords : [];
      const leg2Coords: [number, number][] = p2 ? p2.coords : [];

      multiFloorRoutes = {
        leg1: leg1Coords,
        leg2: leg2Coords,
        fromFloorId: fromLoc.floorId,
        toFloorId: toLoc.floorId
      };
      
      isMultiFloor = true;
      
      // Start on the source floor
      finalRoute = leg1Coords;
      activeFloorId = fromLoc.floorId;
    }
  }

  const steps = generateSemanticSteps(
    isExternal ? 'EXTERNAL' : data.locations.find(l => l.id === fromLocId)?.name || 'Starting Point',
    toLoc.name,
    activeGate.name,
    isMultiFloor,
    fromFloorId,
    toLoc.floorId,
    activeFloorId
  );

  return {
    fromId: fromLocId,
    toId: toLocId,
    currentFloorId: activeFloorId,
    route: finalRoute,
    highlighted: [toLoc.spaceId],
    extStart: isExternal ? activeGate.extStart : undefined,
    selectedGateId: optimalGateId,
    multiFloorRoutes,
    steps
  };
}
